// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n'
import router from './router'
import messages from './locale'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Sentry.init({
  dsn: 'https://83c7c7db2dcb4c24a6437b7abac60595@sentry.io/1522291',
  integrations: [new Integrations.Vue({Vue, attachProps: true})]
})

Vue.config.productionTip = false

var VueCookie = require('vue-cookie')
Vue.use(VueCookie)
Vue.use(VueI18n)

var userLang = (navigator.language || navigator.userLanguage)
userLang = userLang === 'en' ? 'en' : 'it'

const i18n = new VueI18n({
  locale: userLang,
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  i18n,

  mounted () {
    if (window.fcWidget) {
      window.fcWidget.init({
        'token': '8cd4a741-d339-430f-91e9-075f0a56d52f',
        'host': 'https://wchat.freshchat.com'
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js